//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import moment from 'moment-timezone';

import {
  DateRangeAlias,
  getAliasedDateRange,
  IAliasedDateRange,
} from '@components/date-range-picker/dateRangePickerModels';
import DateString, { DATE_STRING_FORMAT } from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

export function parseInputDate(
  d: string,
): { isValid: false } | { isValid: true; parsed: DateString } {
  // Regex tests for 1-2 month digits, 1-2 day digits, and 2 or 4 year digits (but not 3).
  // Moment is more lenient and makes more inputs valid than we want.
  // e.g. 12/230/2020
  if (
    !(/\d{1,2}\/\d{1,2}\/\d{2}/.test(d) || /\d{1,2}\/\d{1,2}\/\d{4}/.test(d)) ||
    (/\d{1,2}\/\d{1,2}\/\d{3}/.test(d) && !/\d{1,2}\/\d{1,2}\/\d{4}/.test(d))
  ) {
    return { isValid: false };
  }

  const mom = /\d{1,2}\/\d{1,2}\/\d{4}/.test(d)
    ? moment(d, 'MM/DD/YYYY')
    : moment(d, 'MM/DD/YY');

  if (mom.isValid()) {
    return {
      isValid: true,
      parsed: mom.format(DATE_STRING_FORMAT) as DateString,
    };
  }
  return { isValid: false };
}

export function getCustomDateRangePickerAliases(
  timeZone: TimeZoneId,
  aliases: DateRangeAlias[] = [
    'last7Days',
    'last30Days',
    'last3Months',
    'last1Year',
  ],
): IAliasedDateRange[] {
  return aliases.map((alias) => getAliasedDateRange(alias, timeZone));
}
